import React from 'react';
import PropTypes from 'prop-types';

import Loader from 'react-loader-spinner';

const validateLoader = ({ message, isFormStep }) => {
  return (
    <>
      <div id="overlay-layer">
        <div id="overlay-story">
          {/* <div>
            <span>{message}</span>
          </div> */}
          <div style={{ marginTop: 20, textAlign: 'center' }}>
            <Loader type="Oval" color="#57a708" height={80} width={80} />
              {isFormStep && <h2 style={{marginBottom: '40px'}}>{message}</h2> }
          </div>
        </div>
      </div>
    </>
  );
};

validateLoader.propTypes = {
  message: PropTypes.string.isRequired
};
export default validateLoader;
